import { render, staticRenderFns } from "./Order_detail.vue?vue&type=template&id=6fdd5580"
import script from "./Order_detail.vue?vue&type=script&lang=js"
export * from "./Order_detail.vue?vue&type=script&lang=js"
import style0 from "./Order_detail.vue?vue&type=style&index=0&id=6fdd5580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports